import CredencialesAdquirentePanel from '@/components/settings/credenciales/CredencialesAdquirentePanel';

export default function CredencialesAdquirentePage() {
  return <CredencialesAdquirentePanel />;
}
